module.exports = __webpack_public_path__ + "img/avalia-spin.eff59f96.gif";